__turbopack_context__.v({
  "by-toast-enter": "Toast-module__MOS8JG__by-toast-enter",
  "by-toast-exit": "Toast-module__MOS8JG__by-toast-exit",
  "by-toast-fade": "Toast-module__MOS8JG__by-toast-fade",
  "by-toast-fade-out": "Toast-module__MOS8JG__by-toast-fade-out",
  "content": "Toast-module__MOS8JG__content",
  "description": "Toast-module__MOS8JG__description",
  "error": "Toast-module__MOS8JG__error",
  "icon": "Toast-module__MOS8JG__icon",
  "info": "Toast-module__MOS8JG__info",
  "shadow": "Toast-module__MOS8JG__shadow",
  "success": "Toast-module__MOS8JG__success",
  "title": "Toast-module__MOS8JG__title",
  "toast": "Toast-module__MOS8JG__toast",
  "toastRegion": "Toast-module__MOS8JG__toastRegion",
  "toastRegionBottom": "Toast-module__MOS8JG__toastRegionBottom",
  "toastRegionMiddle": "Toast-module__MOS8JG__toastRegionMiddle",
  "toastRegionTop": "Toast-module__MOS8JG__toastRegionTop",
  "trash": "Toast-module__MOS8JG__trash",
  "warning": "Toast-module__MOS8JG__warning",
});
